import React, { useEffect, useState } from 'react'
import DetailsBox from '../../../components/Cards/DetailsBox'
import API from '../../../services/API'
import { DataGrid } from '@mui/x-data-grid'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import KanbanTab from '../../../components/Kanban/KanbanTab'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Paper from '@mui/material/Paper'

const Sales = () => {
  const [loading, setLoading] = useState(true)
  const [downloadError, setDownloadError] = useState(false)
  const [events, setEvents] = useState([])

  const loadEvents = () => {
    API.get('/events/sales')
      .then((res) => res.status === 200 && setEvents(res.data))
      .catch((e) => {
        console.log(e)
        setDownloadError(true)
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => loadEvents(), [])
  const navigate = useNavigate()

  return (
    <Box component={Paper} padding={1}>
      <KanbanTab
        items={events}
        selectedStatuses={['Potential', 'Interested', 'Quote Sent']}
        urlPrefix='/events/'
      />
    </Box>
  )
}

export default Sales
